<template>

    <div class="layout__container">

        <div class="layout__width-80 layout__padding-clear">
            <div class="layout__padding-20px">

                <div class="layout__position-left layout__width-100 layout__padding__top-20px">
                    <h2 class="text__align-center text__colour-teal layout__margin__top-10">Billing Orders Search</h2>
                    <AdminOrdersSearch v-bind:searchParams="searchParams" v-bind:orders="orders"
                                       v-bind:loading="loading" v-bind:resultsCount="resultsCount"></AdminOrdersSearch>
                </div>

                <div class="layout__width-100 layout__position-left">
                    <el-table :data="orders" style="width: 100%;"
                              v-on:row-click="viewOrders"
                              class="layout__height-600px layout__scrolling__right layout__margin__bottom-30"
                              v-loading.fullscreen.lock="loading">
                        <el-table-column prop="orderId" label="Customer Id" width="100">
                        </el-table-column>
                        <el-table-column prop="ordered" label="Ordered" width="120" :formatter="formatDateDDMMYYYY">
                        </el-table-column>
                        <el-table-column prop="sourceId" label="Source Id" width="120">
                        </el-table-column>
                        <el-table-column prop="jobId" label="PDC Id" width="120">
                        </el-table-column>
                        <el-table-column prop="type" label="Type" width="140">
                        </el-table-column>
                        <el-table-column prop="status" label="Status" width="140">
                        </el-table-column>
                        <el-table-column prop="branch" label="Branch" width="100">
                        </el-table-column>
                        <el-table-column prop="name" label="Name" width="300">
                        </el-table-column>
                        <el-table-column prop="jobName" label="Job Name" width="540" class="text__wordwrap">
                        </el-table-column>
                        <el-table-column prop="quantity" label="Qty" width="100">
                        </el-table-column>
                        <el-table-column prop="productCode" label="Product" width="200">
                        </el-table-column>
                        <el-table-column prop="billNetTotal" label="Value" width="100">
                        </el-table-column>
                        <el-table-column prop="customer.territory" label="Territory" width="240">
                        </el-table-column>
                    </el-table>
                </div>

                <div class="layout__padding-clear layout__width-60">
                    <div class="layout__padding-20-0">
                        <el-pagination class=""
                                       @size-change="handleSizeChange"
                                       @current-change="handleCurrentChange"
                                       :current-page="this.searchParams.currentPage"
                                       :page-sizes="[20, 40, 60, 80, 100]"
                                       :page-size="this.searchParams.pagination"
                                       layout="total, sizes, prev, pager, next, jumper"
                                       :total="this.resultsCount">
                        </el-pagination>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>

    import AdminOrdersSearch from '../../components/search/AdminOrdersSearch.vue';
    import {axios} from '@/mixins/Axios.js';
    import {csvDownloadHelper} from '@/mixins/CsvDownloadHelper.js';
    import Pagination from "../../components/Pagination";
    import {pagination} from '@/mixins/Pagination.js';
    import {dataFormatter} from '@/mixins/DataFormatter.js';

    export default {
        name: "orders",
        mixins: [axios, csvDownloadHelper, pagination, dataFormatter],
        components: {
            Pagination,
            AdminOrdersSearch,

        },
        props: {
            view: ''
        },
        data() {
            return {
                resultsCount: '',
                orders: [],
                start: 1,
                end: 20,
                pagination: 20,
                loading: false,
                searchParams: {
                    orderSource: '',
                    orderSourceId: null,
                    orderStatus: 'ANY STATUS',
                    orderFreeText: '',
                    assignment: null,
                    territory: null,
                    top: 20,
                    pagination: 20,
                    skip: 0,
                    currentPage: 1,
                    salesDateRange: []

                },
            }
        },
        created() {

            this.isUserAuthorised();
        },
        methods: {
            viewOrders(order) {
                console.log(order)
                this.$router.push({
                    name: '/billing/orders/details',
                    query: {
                        source: order.source,
                        id: order.sourceId,
                    }
                })
            },
            resultsPerPage() {
                document.getElementById('getOrdersPagination').click()
            },
            csv() {
                document.getElementById('downloadAllResults').click()
            }
        }
    }
    ;
</script>